interface Props {
  value: number | string;
}

export const convertNumberComma = (x: number | string) =>
  x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

function NumberWithComma({ value }: Props) {
  return <>{convertNumberComma(value)}</>;
}

export default NumberWithComma;
